import './pie_chart_view.js.coffee'
class Monitoring.Views.Charts.HierarchyPieChartView extends Monitoring.Views.Charts.PieChartView
  hierarchySelectingTemplate: JST["backbone/templates/monitoring/hierarchy_select"]

  initialize: (@options = {}) =>
    super
    @url = '/monitoring/dashboard/charts/hierarchy'

  render: ->
    @$el.html(@template({
      title: @title
    }))
    @

  _legendClick: (event) =>
    name = event.target.name
    series = @chart.series
    for i in [0...series.length]
      points = series[i].points
      for j in [0...points.length]
        point = points[j]
        if point.main_branch == name
          point.setVisible(!point.visible, false)
    @chart.redraw()
    false

  _pieClick: (event) =>
    return if @_settings.avoid_preview
    query = @getNewQuery(event)
    query = new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays) if @shiftedDays
    @createPreviewDashboard(query)
    false

  getNewQuery: (event) ->
    tags = _.uniq(@_join_tags(event.point))
    query = @searchQuery.deepCopy()
    if _.isEmpty(query.get('primary_tags'))
      key = 'primary_tags'
    else if query.get('primary_tags')[0] == 'allTags'
      key = 'primary_tags'
    else
      key = 'secondary_tags'
    query.set(key, tags)
    return query

  _join_tags: (node) ->
    tags = []
    if node.tags
      tags = tags.concat node.tags
    if node.children
      for i in [0...node.children.length]
        tags = tags.concat @_join_tags node.children[i]
    tags

  _getOptions: ->
    defaultOptions = new Customer.Reports.PieOptions(
      container: @$el.find('.chart')[0]
      onToggleMaximize: => @toggleMaximize()
      isMaximized: @_settings.maximized
    ).get()

    customOptions = {
      chart:
        type: "pie"
        backgroundColor:'transparent'
      title:
        text: null
      plotOptions:
        pie:
          borderColor: "rgba(0,0,0,0)"
          point:
            events:
              legendItemClick: @_legendClick
    }

    options = $.extend(true, defaultOptions, customOptions)
    options.series = @_series()
    options.tooltip.formatter = @_tooltipFormatter

    customOptions = @customOptions()
    if customOptions.length > 0
      options.exporting.buttons.contextButton.menuItems.push({separator: true}, customOptions...)

    return options

  customOptions: =>
    []

  _getChartOptions: ->
    {}

  _getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', 'tags')
    if @shiftedDays
      new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays)
    else
      query

  onBenchmarkByDay: () ->
    return

  onBenchmarkByWeek: () ->
    return

  onRemoveBenchmark: () ->
    return
